module.exports = __webpack_public_path__ + "img/avi.aa4c0990.svg";